import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Добавьте и сохраните все вариации ")
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Не настроено соответствие для данного размера. Нажмите, чтобы перейти к управлению размерами и произвести настройку ")
const _hoisted_4 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_5 = {
  key: 0,
  style: {"color":"blue","max-width":"250px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Сохранить")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check = _resolveComponent("check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_close = _resolveComponent("close")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_VariationPrint = _resolveComponent("VariationPrint")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, [
      _hoisted_1,
      (_ctx.isCompleteVariations && !_ctx.isUpdateCreatedVariations && !_ctx.isSaveNewVariations)
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            size: "40px",
            color: "green"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_check)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variations, (variation, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: variation.id || key,
        style: {"gap":"20px","display":"flex","align-items":"flex-start","padding-bottom":"20px","border-bottom":"1px solid #dbdde1","margin-bottom":"20px"}
      }, [
        _createTextVNode(_toDisplayString(key + 1), 1),
        _createVNode(_component_el_select, {
          modelValue: variation.sizeTypeId,
          "onUpdate:modelValue": ($event: any) => ((variation.sizeTypeId) = $event),
          disabled: 
				(Number.isInteger(variation.state) && variation.state !== _ctx.enumVariationState.counted) || _ctx.isDisableSelect
			,
          class: "m-2",
          placeholder: "Select size type",
          size: "large",
          onChange: 
				() => {
					variation.sizeValueId = null
					variation.sizeReferenceId = null
					_ctx.canSelectSizeReferences[key] = true
				}
			,
          onFocus: _cache[0] || (_cache[0] = () => _ctx.addFieldVariation()),
          onBlur: _cache[1] || (_cache[1] = () => _ctx.addFieldVariation())
        }, {
          default: _withCtx(() => [
            (_ctx.sizeTypes?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.sizeTypes, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_select, {
            modelValue: variation.sizeValueId,
            "onUpdate:modelValue": ($event: any) => ((variation.sizeValueId) = $event),
            disabled: 
					(Number.isInteger(variation.state) && variation.state !== _ctx.enumVariationState.counted) || _ctx.isDisableSelect
				,
            class: "m-2",
            placeholder: "Select size value",
            size: "large",
            onChange: ($event: any) => (_ctx.onSelectSizeValue(variation, key)),
            onFocus: _cache[2] || (_cache[2] = () => _ctx.addFieldVariation()),
            onBlur: _cache[3] || (_cache[3] = () => _ctx.addFieldVariation())
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSizeValues(variation.sizeTypeId), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]),
          (_ctx.canSelectSizeReferences[key] === false)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                style: {"color":"red","text-decoration-style":"dotted","max-width":"250px"},
                to: "/size/manager"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            modelValue: variation.sizeReferenceId,
            "onUpdate:modelValue": ($event: any) => ((variation.sizeReferenceId) = $event),
            class: "m-2",
            disabled: !_ctx.canEditSizeReference(variation) || _ctx.canSelectSizeReferences[key] === false,
            placeholder: "Select size reference",
            size: "large",
            onFocus: _cache[4] || (_cache[4] = () => _ctx.addFieldVariation()),
            onBlur: _cache[5] || (_cache[5] = () => _ctx.addFieldVariation())
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeValuesByCategoryGroupId, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
          (
					_ctx.canEditSizeReference(variation) &&
					variation.sizeReferenceId &&
					_ctx.defaultSizeReferences[variation.sizeValueId] !== variation.sizeReferenceId
				)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Вы изменили соответствие размера "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            modelValue: variation.originalQuantity,
            "onUpdate:modelValue": ($event: any) => ((variation.originalQuantity) = $event),
            disabled: 
					(Number.isInteger(variation.state) && variation.state !== _ctx.enumVariationState.counted) || _ctx.isDisableSelect
				,
            class: "m-2",
            placeholder: "Input original quantity",
            size: "large",
            maxlength: 8,
            onFocus: _cache[6] || (_cache[6] = () => _ctx.addFieldVariation()),
            onBlur: _cache[7] || (_cache[7] = () => _ctx.addFieldVariation()),
            onInput: val => _ctx.clearZero(val, variation)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onInput"])
        ]),
        (!variation.id && Object.values(variation).some(el => el))
          ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              style: {"cursor":"pointer"},
              onClick: ($event: any) => (_ctx.clearFieldsNotSavedVariation(variation))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_close)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(_component_el_button, {
      disabled: !_ctx.isSave || _ctx.isSaving,
      onClick: _ctx.prepareVariations
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    (_ctx.product.variations?.length && _ctx.sizeTypes?.length && _ctx.sizeValues?.rows?.length)
      ? (_openBlock(), _createBlock(_component_VariationPrint, {
          key: 0,
          "size-types": _ctx.sizeTypes,
          "size-values": _ctx.sizeValues.rows
        }, null, 8, ["size-types", "size-values"]))
      : _createCommentVNode("", true)
  ], 64))
}